import $ from "jquery";
import BasePage from "pages/base_page";
import { isSessionActive } from "lib/currentUser/session";

const showMoreExperts = (event) => {
  event.preventDefault();
  $(".expert-authors").addClass("show-all");
};

const clickHandheldTab = (event) => {
  event.preventDefault();
  const section = $(event.target).attr("href");
  $("#tabbed-navigation a.active").removeClass("active");
  $(event.target).addClass("active");
  switch (section) {
    default:
      $(".topic-page").removeClass("sm-display-contributors sm-display-links");
      $(".topic-page").addClass("sm-display-articles");
      break;
    case "#contributors":
      $(".topic-page").removeClass("sm-display-articles sm-display-links");
      $(".topic-page").addClass("sm-display-contributors");
      break;
    case "#links":
      $(".topic-page").removeClass("sm-display-articles sm-display-contributors");
      $(".topic-page").addClass("sm-display-links");
      break;
  }
};

const setTopicFollowedState = (following) => {
  if (following) {
    $(".actions .follow-link").addClass("followed");
  } else {
    $(".actions .follow-link").addClass("not-followed");
  }
};

const fetchTopicFollowedState = () => {
  $.ajax({
    type: "GET",
    url: `${document.location.pathname}/following`,
    success: ({ following }) => setTopicFollowedState(following),
    failure: () => setTopicFollowedState(false),
  });
};

export default class TopicPage extends BasePage {
  initialize(options) {
    super.initialize(options);

    this.delegateEvents({
      "click #tabbed-navigation a": clickHandheldTab,
      "click .expert-authors .more a": showMoreExperts,
    });

    if (isSessionActive()) {
      fetchTopicFollowedState();
    } else {
      setTopicFollowedState(false);
    }
  }
}
